import { useContext, useState, useEffect, useCallback, useRef } from "react";
import { AuthContext } from "../context";
import { doctorServices, productsServices } from "../services";

export function useAssignToDoctor() {
  const { authState } = useContext(AuthContext);
  const isMasterAdmin = authState.user.role._id === "5fdb9e3db3bfce86908e440f";

  const [laboratoryId, setLaboratoryId] = useState(
    isMasterAdmin ? null : authState.user.laboratory._id
  );
  // const [labs, setLabs] = useState(null);

  const [doctors, setDoctors] = useState(null);
  const [loadingDoctors, setLoadingDoctors] = useState(true);
  const [paginationDoctors, setPaginationDoctors] = useState({
    page: 1,
    limit: 10,
    count: 100,
    query: "",
  });

  const [paginationProducts, setPaginationProducts] = useState({
    page: 1,
    limit: 10,
    count: 100,
    query: "",
  });
  const [products, setProducts] = useState(null);
  const [loadingProducts, setLoadingProducts] = useState(false);

  const [assignment, setAssignment] = useState({});

  const [productsSelected, setProductsSelected] = useState(null);
  const [doctorsSelected, setDoctorsSelected] = useState(null);

  const [error, setError] = useState(null);

  // useEffect(() => {
  //   console.log({ doctorsSelected, productsSelected, assignment });
  // }, [doctorsSelected, productsSelected, assignment]);

  const data = useCallback(async () => {
    try {
      setLoadingDoctors(true);
      const { status, response: res } = await doctorServices.getDoctorsFilter({
        text: paginationDoctors.query,
        page: paginationDoctors.page,
        limit: paginationDoctors.limit,
        token: authState.token,
      });
      if (status !== 200) throw new Error(res.message);
      const { doctors, limit, total, page } = res;
      setLoadingDoctors(false);
      changePaginationDoctors({
        action: "FETCH",
        data: {
          page: page,
          limit: limit,
          count: total,
        },
      });
      setDoctors(doctors);
    } catch (error) {
      setError(error);
      setLoadingDoctors(false);
    }
  }, [
    paginationDoctors.limit,
    paginationDoctors.page,
    paginationDoctors.query,
  ]);

  useEffect(() => {
    data();
  }, [
    paginationDoctors.limit,
    paginationDoctors.page,
    paginationDoctors.query,
  ]);

  const loadSamples = useCallback(async () => {
    try {
      setLoadingProducts(true);
      const { status, response } = await productsServices.getProductsFilter({
        text: paginationProducts.query,
        laboratoryId: isMasterAdmin ? "ALL" : authState.user.laboratory._id,
        page: paginationProducts.page,
        limit: paginationProducts.limit,
        token: authState.token,
        // doctorId: doctorToAssign,
      });
      if (status === 200) {
        setProducts(response.products.filter(p=>p.status===1 || p.status==='661821d27b4df03548c403f8'));
        changePaginationProducts({
          action: "FETCH",
          data: {
            limit: response.limit,
            count: response.total,
            page: response.page,
          },
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingProducts(false);
    }
  }, [
    paginationProducts.page,
    paginationProducts.limit,
    paginationProducts.query,
  ]);
  useEffect(() => {
    loadSamples();
  }, [
    paginationProducts.page,
    paginationProducts.limit,
    paginationProducts.query,
    laboratoryId,
  ]);

  const changeLaboratoryId = useCallback((labId) => {
    setLaboratoryId(labId);
  }, []);

  const changeAssignment = useCallback(({ doctorId, productId, qty }) => {
    setAssignment((prev) => {
      const doctorProducts = prev[doctorId] || {};

      return {
        ...prev,
        [doctorId]: {
          ...doctorProducts,
          [productId]: { doctorId, productId, qty },
        },
      };
    });
  }, []);
  const changeDoctorsSelected = useCallback(({ data }) => {
    setDoctorsSelected((prev) => {
      const doctorsSelected = toogleFromState({
        source: prev,
        key: data.doctorId,
        data,
      });
      revalidateAssignment({ data: doctorsSelected, type: "doctors" });
      return doctorsSelected;
    });
  }, []);
  const changeProductsSelected = useCallback(({ data }) => {
    setProductsSelected((prev) => {
      const productsSelected = toogleFromState({
        source: prev,
        key: data.productId,
        data,
      });
      revalidateAssignment({ data: productsSelected, type: "products" });
      return productsSelected;
    });
  }, []);
  const toogleFromState = useCallback(({ source, key, data }) => {
    if (!source) return { [key]: data };
    const prevKeys = Object.keys(source);
    if (!prevKeys.includes(key)) return { ...source, [key]: data };
    else {
      const { [key]: _, ...rest } = source;
      return rest;
    }
  }, []);


  const revalidateAssignment = useCallback(({ data, type }) => {
    setAssignment((prev) => {
      if (!Object.keys(prev).length) return prev;
      const dataKeys = Object.keys(data);
      if (!dataKeys.length) return {};

      // revalidar por doctores
      if (type === "doctors") {
        const revalidatedAssignment = {};
        Object.keys(prev).forEach((doctorId) => {
          if (dataKeys.includes(doctorId)) {
            revalidatedAssignment[doctorId] = { ...prev[doctorId] };
          }
        });
        return revalidatedAssignment;
      }

      // revalidar por productos
      if (type === "products") {
        const revalidatedAssignment = {};
        Object.keys(prev).forEach((doctorId) => {
          const productsForDoctor = prev[doctorId];
          const filteredProducts = {};

          Object.keys(productsForDoctor).forEach((productId) => {
            if (dataKeys.includes(productId)) {
              filteredProducts[productId] = productsForDoctor[productId];
            }
          });

          // Solo mantener doctor si le quedan productos asignados
          if (Object.keys(filteredProducts).length > 0) {
            revalidatedAssignment[doctorId] = filteredProducts;
          }
        });
        return revalidatedAssignment;
      }

      return prev;
    });
  }, []);


  const changePaginationProducts = useCallback(({ action, data }) => {
    setPaginationProducts((prev) => {
      const pagination = changePagination({ action, source: prev, data });
      return pagination;
    });
  }, []);
  const changePaginationDoctors = useCallback(({ action, data }) => {
    setPaginationDoctors((prev) => {
      const pagination = changePagination({ action, source: prev, data });
      return pagination;
    });
  }, []);
  const changePagination = useCallback(({ action, source, data }) => {
    switch (action) {
      case "PAGE":
        return { ...source, page: data.page };
      case "QUERY":
        return {
          ...source,
          page: 1,
          query: data.query,
        };
      case "LIMIT":
        return {
          ...source,
          page: 1,
          limit: data.limit,
        };
      case "FETCH":
        return { ...source, ...data };
      default:
        break;
    }
  }, []);

  const restoreProductsSelected = useCallback(() => {
    setProductsSelected(null);
  }, []);
  const restoreDoctorsSelected = useCallback(() => {
    setDoctorsSelected(null);
  }, []);
  const restoreAssignments = useCallback(() => {
    setAssignment({});
  }, []);
  const value = {
    error,

    doctors,
    paginationDoctors,
    changePaginationDoctors,
    loadingDoctors,

    products,
    paginationProducts,
    changePaginationProducts,
    loadingProducts,

    changeLaboratoryId,

    assignment,
    changeAssignment,

    changeProductsSelected,
    productsSelected,

    changeDoctorsSelected,
    doctorsSelected,
    restoreProductsSelected,
    restoreDoctorsSelected,
    restoreAssignments
  };

  return value;
}
